import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { getDisciplineList } from "../../../actions/Authorization";
import { DisciplineDispatchTypes } from "../../../models/DispatchTypes/Authorization";
import { DisciplinePayload } from "../../../models/Authorization";
import Disciplines from "../Components/DisciplineList";

const mapStateToProps = ({ disciplineListState }: ApplicationState) => ({
    disciplineListData: disciplineListState,
});

type DispatchTypes = DisciplineDispatchTypes;

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    DispatchTypes
  >
) => {
  return {
    getDisciplineList: (payload: DisciplinePayload) => {
      dispatch(getDisciplineList(payload));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Disciplines);
